export default class e { // individual constant
  static g_env = 'pdn';
}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */

